module.exports = __webpack_public_path__ + "static/media/Sharp-Technology-IGZO-Power-Consumption-3.0090c39f.png";